export default "__VITE_PUBLIC_ASSET__0da85483__"